import { useLocation } from "react-router-dom";
import Preview from "./optionstTabs/preview/preview";
import Statistics from "./optionstTabs/statistics/statistics";
import Lineups from "./optionstTabs/lineups/lineups";
import MinuteByMinuteTimeline from "./optionstTabs/minuteByMinuteTimeline/minuteByMinuteTimeline";
import MatchComplete from "./matchComplete/matchComplete";
import WidgetContainer from "../reusablesComponents/containerWidget";
import "./minuteByMinute.sass";

export default function MinuteByMinute({ type = "", matchId = "", refresh = false, country }) {
  const location = useLocation();

  // Determinar qué componente mostrar basado en la ruta
  const getComponentFromRoute = () => {
    const pathname = location.pathname;

    if (pathname.includes("/preview")) {
      return "preview";
    } else if (pathname.includes("/statistics")) {
      return "statistics";
    } else if (pathname.includes("/lineups")) {
      return "lineups";
    } else if (pathname.includes("/commentary")) {
      return "commentary";
    } else if (pathname.includes("/score")) {
      return "score";
    }
    return null;
  };

  const activeComponent = getComponentFromRoute();

  return (
    <WidgetContainer className="minute-by-minute-container" id="minute-by-minute-container">
      {/* Mostrar componente individual según la ruta */}
      {activeComponent === "score" && <MatchComplete matchId={matchId} type={type} refresh={refresh} country={country} />}

      {activeComponent === "preview" && <Preview matchId={matchId} type={type} refresh={refresh} country={country} />}

      {activeComponent === "statistics" && <Statistics matchId={matchId} type={type} refresh={refresh} country={country} />}

      {activeComponent === "lineups" && <Lineups matchId={matchId} type={type} refresh={refresh} country={country} />}

      {activeComponent === "commentary" && <MinuteByMinuteTimeline matchId={matchId} type={type} refresh={refresh}  country={country}/>}
    </WidgetContainer>
  );
}